module.exports = __webpack_public_path__ + "mq.svg?ce45144d9a07d169c093e48e9b58d05c";